export const setIfExists = (key: string, referenceObj, targetObj) => {
  if (referenceObj.hasOwnProperty(key)) {
    targetObj[key] = referenceObj[key]
  }
}
